import { useEffect, useState } from "react";
import { deleteInquiry, getInquiries } from "@/lib/cloudApi";
import { toast } from "sonner";
import { Mail, Phone, Trash2, MessageCircle } from "lucide-react";

export default function AdminInquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const data = await getInquiries();
      setItems(Array.isArray(data) ? data : []);
    }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this inquiry?")) return;
    await deleteInquiry(id);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="p-10" data-testid="admin-inquiries">
      <div className="eyebrow text-[#C99A45]">Leads</div>
      <h1 className="font-serif-display text-5xl mt-3">Inquiries</h1>
      <div className="gold-divider my-6"></div>

      {loading ? <div className="text-[#F7F1E8]/60 mt-10">Loading...</div> : items.length === 0 ? (
        <div className="text-[#F7F1E8]/60 mt-10 border border-[#C99A45]/20 p-12 text-center">No inquiries yet.</div>
      ) : (
        <div className="space-y-4 mt-8">
          {items.map((i) => (
            <div key={i.id} className="border border-[#C99A45]/20 p-6" data-testid={`inquiry-${i.id}`}>
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                  <h3 className="font-serif-display text-2xl">{i.name}</h3>
                  <div className="eyebrow text-[10px] text-[#C99A45]/80 mt-1">
                    {i.event_type || "—"} · {i.wedding_city || "—"} · {i.wedding_date || "Date not set"}
                  </div>
                </div>
                <div className="flex gap-2 items-center">
                  <a href={`tel:+91${i.phone}`} className="px-3 py-2 border border-[#C99A45]/40 text-[#C99A45] text-xs hover:bg-[#C99A45] hover:text-black flex items-center gap-1"><Phone size={11} /> Call</a>
                  <a href={`https://wa.me/91${i.phone.replace(/[^0-9]/g, "")}`} target="_blank" rel="noreferrer" className="px-3 py-2 border border-green-500/40 text-green-500 text-xs hover:bg-green-500 hover:text-white flex items-center gap-1"><MessageCircle size={11} /> WhatsApp</a>
                  <a href={`mailto:${i.email}`} className="px-3 py-2 border border-[#C99A45]/40 text-[#C99A45] text-xs hover:bg-[#C99A45] hover:text-black flex items-center gap-1"><Mail size={11} /> Email</a>
                  <button onClick={() => del(i.id)} className="px-3 py-2 border border-[#E52717]/40 text-[#E52717] text-xs hover:bg-[#E52717] hover:text-white" data-testid={`del-inq-${i.id}`}><Trash2 size={11} /></button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-5 text-sm">
                <div><span className="eyebrow text-[9px] text-[#C99A45]/70 block">Phone</span>{i.phone}</div>
                <div><span className="eyebrow text-[9px] text-[#C99A45]/70 block">Email</span>{i.email}</div>
                <div><span className="eyebrow text-[9px] text-[#C99A45]/70 block">Budget</span>{i.expected_budget || "—"}</div>
                <div className="md:col-span-3"><span className="eyebrow text-[9px] text-[#C99A45]/70 block">Venue</span>{i.venue || "—"}</div>
                {i.message && <div className="md:col-span-3"><span className="eyebrow text-[9px] text-[#C99A45]/70 block">Message</span><p className="mt-1 text-[#F7F1E8]/80">{i.message}</p></div>}
              </div>
              <div className="eyebrow text-[9px] text-[#F7F1E8]/40 mt-4">
                {new Date(i.created_at).toLocaleString()} · Email {i.email_sent ? "sent ✓" : "not sent"}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
